import { InlinePaperChipWidget } from '../../../components/widgets/InlinePaperChipWidget';
import { PaperTitleOverrideProps } from '../shared/components/PapersPanel';

export function PaperTitle(props: PaperTitleOverrideProps): JSX.Element {
  const { corpusId, title } = props;
  return (
    <InlinePaperChipWidget
      corpusId={corpusId}
      paperTitle={title}
      isMultiLine={true}
      isFullWidth={true}
      isDarkMode={true}
    />
  );
}
